import styled from 'styled-components';
import { overlayScrim } from 'pages/styles';
import { overlayContentZIndex, overlayZIndex } from '../Modal/Modal.styled';

export const Bg = styled.div`
  height: 100%;
  width: 100%;
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: ${overlayZIndex};
  /* Alpha is in the color — opacity only toggles visibility (avoids a pure-black paint frame). */
  background: ${overlayScrim};
  opacity: 0;
  display: none;
  transition: opacity ease-in 250ms;
`;

export const Container = styled.div`
  position: fixed;
  top: 0px;
  left: -200%;
  width: max-content;
  height: 100svh;
  z-index: ${overlayContentZIndex};
  display: flex;
`;